import FetchDcddUser from "./page/FetchDcddUser"

const NewRegisterDcddUser:React.FC = () =>{
    return(
        <>
        <FetchDcddUser/>
        </>
    )
};
export default NewRegisterDcddUser;